export const BANNER_TRANSLATIONS = {
  es: {
    message: 'Detectamos que tu navegador está en {language}. ¿Cambiar idioma?',
    accept: 'Cambiar',
    dismiss: 'No, gracias',
    acceptAriaLabel: 'Cambiar a {language}',
    dismissAriaLabel: 'Mantener idioma actual'
  },
  en: {
    message: 'We detected your browser is in {language}. Switch language?',
    accept: 'Switch',
    dismiss: 'No, thanks',
    acceptAriaLabel: 'Switch to {language}',
    dismissAriaLabel: 'Keep current language'
  },
  gl: {
    message: 'Detectamos que o teu navegador está en {language}. Cambiar idioma?',
    accept: 'Cambiar',
    dismiss: 'Non, grazas',
    acceptAriaLabel: 'Cambiar a {language}',
    dismissAriaLabel: 'Manter idioma actual'
  },
  it: {
    message: 'Abbiamo rilevato che il tuo browser è in {language}. Cambiare lingua?',
    accept: 'Cambia',
    dismiss: 'No, grazie',
    acceptAriaLabel: 'Cambia a {language}',
    dismissAriaLabel: 'Mantieni la lingua attuale'
  },
  pt: {
    message: 'Detectamos que o seu navegador está em {language}. Mudar idioma?',
    accept: 'Mudar',
    dismiss: 'Não, obrigado',
    acceptAriaLabel: 'Mudar para {language}',
    dismissAriaLabel: 'Manter idioma atual'
  },
  fr: {
    message: 'Nous avons détecté que votre navigateur est en {language}. Changer de langue ?',
    accept: 'Changer',
    dismiss: 'Non, merci',
    acceptAriaLabel: 'Changer pour {language}',
    dismissAriaLabel: 'Garder la langue actuelle'
  },
  de: {
    message: 'Wir haben erkannt, dass Ihr Browser auf {language} eingestellt ist. Sprache wechseln?',
    accept: 'Wechseln',
    dismiss: 'Nein, danke',
    acceptAriaLabel: 'Zu {language} wechseln',
    dismissAriaLabel: 'Aktuelle Sprache beibehalten'
  },
  ca: {
    message: 'Hem detectat que el teu navegador està en {language}. Canviar idioma?',
    accept: 'Canviar',
    dismiss: 'No, gràcies',
    acceptAriaLabel: 'Canviar a {language}',
    dismissAriaLabel: 'Mantenir idioma actual'
  },
  eu: {
    message: '{language} hizkuntzan dagoela detektatu dugu zure nabigatzailean. Hizkuntza aldatu?',
    accept: 'Aldatu',
    dismiss: 'Ez, eskerrik asko',
    acceptAriaLabel: '{language} hizkuntzara aldatu',
    dismissAriaLabel: 'Uneko hizkuntza mantendu'
  },
  nap: {
    message: 'Avimmo rilevato ca \'o browser tuojo è \'n {language}. Cagnà lengua?',
    accept: 'Cagna',
    dismiss: 'No, grazie',
    acceptAriaLabel: 'Cagna a {language}',
    dismissAriaLabel: 'Mantené \'a lengua attuale'
  }
}
